<template>
    <!-- <div class="page list_page gray_bg"> -->
    <div>
        <BACK title="徵才詳情"/>
        <template v-if="detailLoading">
            <div class="loading">
                <i class="el-icon-loading"></i>
            </div>
        </template>
        <template v-else>
            <div class="page_padding" v-if="jobDetail">
                <ul class="list">
                    <li class="item">
                        <p class="tit">[{{interviewTypeName}}]{{(jobDetail || {}).title}}</p>
                        <p class="time">{{(jobDetail || {}).date | moment("YYYY/MM/DD")}}</p>
                        <p class="info">
                            <span class="tag">{{(jobDetail || {}).area}}</span>
                            <span class="pay">NT${{formatNumber((jobDetail || {}).payFrom) || '不限'}}-{{formatNumber((jobDetail || {}).payTo) || '不限'}}/月</span>
                        </p>
                    </li>
                </ul>
                <div class="detail">
                    <p class="tit">內容敘述</p>
                    <p class="content">{{(jobDetail || {}).content}}</p>
                    <p class="content" v-if="(jobDetail || {}).contactName">聯絡人:{{(jobDetail || {}).contactName}}</p>
                    <p class="content" v-if="(jobDetail || {}).contactMemo">聯絡資訊:{{(jobDetail || {}).contactMemo}}</p>
                </div>
                <InFeedAdsense
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-9879330354493543"
                    data-ad-slot="5365863390">
                </InFeedAdsense>
            </div>
            <div class="footer_btn" v-if="(jobDetail || {}).myInterview">
                <el-button class="item plan" plain :disabled="loading" @click="handleEdit()">編輯</el-button>
                <el-button class="item" type="success" :disabled="loading" @click="handleDelete()"><i
                    class="el-icon-loading" v-if="loading"></i>刪除
                </el-button>
            </div>
        </template>
    </div>
</template>
<script>
    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'detail',
        components: {
            BACK
        },
        mixins: [FN],
        data() {
            return {
                qkSearch: false
            }
        },
        mounted() {
            //取得詳情資料
            this.getDetail()
        },
        computed: {
            ...mapGetters([
                'jobType',
                'searchArea',
                'jobDetail'
            ]),
            interviewTypeName() {
                const type = (this.jobType || []).filter(({interviewType}) => +interviewType === +(this.jobDetail || {}).interviewType)
                return (type[0] || {}).interviewName
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getDetail() {
                this.detailLoading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'JOB_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                    if (!+(res || {}).code) {
                        this.detailLoading = false
                    }
                })
            },
            handleEdit() {
                const id = this.$route.params.id
                // const { href } = this.$router.resolve({name: 'JobEdit', params:{ id: id}})
                // window.open(href, '_self')
                this.$router.push({name: 'JobEdit', params: {id: id}})
            },
            handleDelete() {
                this.loading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'JOB_DELETE',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleDelete)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            //刪除回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('刪除成功', {
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
                            // window.open(href, '_self')
                            this.$router.replace({name: 'Job', params: {tag: 'my'}})
                            this.$parent.handleSearch()
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            handleBack() {
                //this.$router.push('/job/my')
                this.$router.replace({name: 'Job'})
                //this.$nextTick(() => this.$root.$emit('back'))
            }
        }
    }
</script>
